import { render, staticRenderFns } from "./DirectionalLight.vue?vue&type=template&id=1150a900&"
import script from "./DirectionalLight.vue?vue&type=script&lang=js&"
export * from "./DirectionalLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports